import { render, staticRenderFns } from "./ImportarExportar.vue?vue&type=template&id=5291b00d&scoped=true"
import script from "./ImportarExportar.vue?vue&type=script&lang=js"
export * from "./ImportarExportar.vue?vue&type=script&lang=js"
import style0 from "./ImportarExportar.vue?vue&type=style&index=0&id=5291b00d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5291b00d",
  null
  
)

export default component.exports